export default "__VITE_ASSET__Df0JryvN__"